import { useConfigService } from '@thd-nucleus/experience-context';
import { areMajorityOfProductsMajorAppliances } from '../utils/fulfillment-helpers';

/**
 * Whether the plp-speed UX applies to this page. Major appliance pages keep the legacy UX.
 *
 * @param {Array} [products] - searchModel products, checked for a major appliance majority
 */
export const usePlpSpeedEnabled = (products) => {
  const isPlpSpeedSwitchOn = useConfigService('fs-prop:isPlpSpeedEnabled');
  return !!isPlpSpeedSwitchOn && !areMajorityOfProductsMajorAppliances(products);
};
